
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./GasExport.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";

import { trackPageVisit } from "../competency/PageTracker";



 


 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function GasExport() {

      useEffect(() => {
  
    trackPageVisit("GasExport");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);

  


  const DEFAULT_VALVES = {
  PCV_2601: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("GasExport_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      PCV_2601: { ...DEFAULT_VALVES.PCV_2601, ...parsed.PCV_2601 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("GasExport_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };




  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};




  // ================= INFLOW LOGIC from TEST, FIRST STAGE, SECOND AND THIRD STAGE SEPARATOR to OILY WATER TANK LEVEL TRANSMITTER =================
   
  const [PT_2504, setPT_2504] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2504")) || 0;
            setPT_2504(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_2504, setTT_2504] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_2504")) || 0;
            setTT_2504(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_2504, setFIC_2504] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2504")) || 0;
            setFIC_2504(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


        
  /* ================= VALVE STATUS ================= */

  const isXV2601Open = valves?.XV_2601 === false;
  const isXV2602Open = valves?.XV_2602 === false;
  const isXV2603Closed = valves?.XV_2603 === true;
  const isXV2603Open = valves?.XV_2603 === false;  
  const isXV2604Open = valves?.XV_2604 === false;
  const isXV2605Open = valves?.XV_2605 === false;



      const FIC_2601 = FIC_2504;

      const PT_2601 = PT_2504;

      const TT_2601 = TT_2504;

      const FIC_2602 = isXV2602Open ? 30.24 : 0;
      const TT_2602 = isXV2602Open ? 24 : 28;
      const PT_2602 = isXV2602Open ? 1.3 : 0.03;


// ======================================================
// GAS EXPORT COOLER
// CORRECTED REALISTIC VERSION
// ======================================================

// ======================================================
// OUTPUT VARIABLES
// ======================================================

let TT_2604 = TT_2601;

let FIC_2603 = FIC_2602;

let PT_2603 = PT_2602;

let TT_2603 = TT_2602;

// ======================================================
// CASE 1
// NO GAS FLOW
// ======================================================

if (FIC_2601 <= 0) {

  // ==========================================
  // GAS SIDE
  // ==========================================

  TT_2604 = TT_2601;

  // ==========================================
  // WATER SIDE
  // ==========================================

  FIC_2603 = FIC_2602;

  PT_2603 = PT_2602;

  TT_2603 = TT_2602;
}

// ======================================================
// CASE 2
// WATER INLET VALVE CLOSED
// NO WATER ENTERING COOLER
// ======================================================

else if (!isXV2602Open) {

  // ==========================================
  // GAS NOT COOLED
  // ==========================================

  TT_2604 = TT_2601;

  // ==========================================
  // WATER SIDE DEAD
  // ==========================================

  FIC_2603 = 0;

  PT_2603 = 0.03;

  TT_2603 = 28;
}

// ======================================================
// CASE 3
// WATER INLET OPEN
// BUT OUTLET BLOCKED
// ======================================================

else if (!isXV2601Open) {

  // ==========================================
  // WATER STAGNATION
  // ==========================================

  FIC_2603 = 0;

  PT_2603 = 0.03;

  TT_2603 = 28;

  // ==========================================
  // LITTLE OR NO COOLING
  // ==========================================

  TT_2604 =
    TT_2601 - 2;

  // ==========================================
  // LIMIT
  // ==========================================

  if (TT_2604 < TT_2602 + 3)
    TT_2604 =
      TT_2602 + 3;
}

// ======================================================
// CASE 4
// NORMAL COOLING OPERATION
// BOTH VALVES OPEN
// ======================================================

else {

  // ====================================================
  // WATER/GAS RATIO
  // ====================================================

  const exchangerRatio =
    FIC_2602 / (FIC_2601 + 1);

  // ====================================================
  // COOLING EFFICIENCY
  // ====================================================

  let coolingEfficiency =
    exchangerRatio * 0.80;

  // ====================================================
  // LIMITS
  // ====================================================

  if (coolingEfficiency > 0.85)
    coolingEfficiency = 0.85;

  if (coolingEfficiency < 0.15)
    coolingEfficiency = 0.15;

  // ====================================================
  // TEMPERATURE DIFFERENCE
  // ====================================================

  const deltaT =
    TT_2601 - TT_2602;

  // ====================================================
  // GAS COOLING
  // ====================================================

  const gasCooling =
    deltaT * coolingEfficiency;

  // ====================================================
  // GAS OUTLET TEMP
  // ====================================================

  TT_2604 =
    TT_2601 - gasCooling * 3.8;

  // ====================================================
  // MINIMUM APPROACH TEMP
  // ====================================================

  const minGasTemp =
    TT_2602 + 4;

  if (TT_2604 < minGasTemp)
    TT_2604 = minGasTemp;

  // ====================================================
  // WATER HEATING
  // ====================================================

  const waterHeating =
    gasCooling * 1.243;

  TT_2603 =
    TT_2602 + waterHeating;

  // ====================================================
  // WATER OUTLET FLOW
  // ====================================================

  FIC_2603 =
    FIC_2602 * 0.998;

  // ====================================================
  // WATER OUTLET PRESSURE
  // ====================================================

  PT_2603 =
    PT_2602 * 0.97;

  // ====================================================
  // LIMITS
  // ====================================================

  if (TT_2603 > 60)
    TT_2603 = 60;
}



  const FIC_2605 = FIC_2601 * (valveData?.PCV_2601?.opening || 0)/100;

  const FIC_2604 = FIC_2601 - FIC_2605;


// ======================================================
// GAS METERING STATION
// ======================================================

let FIC_2606 = 0;
let PT_2606 = 0.03;
let TT_2606 = 25;

let FIC_2607 = 0;
let PT_2607 = 0.03;
let TT_2607 = 25;

// ======================================================
// TOTAL INLET FLOW
// ======================================================

const totalGasFlow =
  FIC_2604;

// ======================================================
// CASE 1
// BOTH LINES CLOSED
// ======================================================

if (
  !isXV2604Open &&
  !isXV2605Open
) {

  // ==========================================
  // NO FLOW
  // ==========================================

  FIC_2606 = 0;
  FIC_2607 = 0;

  // ==========================================
  // PRESSURE COLLAPSE
  // ==========================================

  PT_2606 = 0.03;
  PT_2607 = 0.03;

  // ==========================================
  // AMBIENT TEMPERATURE
  // ==========================================

  TT_2606 = 25;
  TT_2607 = 25;
}

// ======================================================
// CASE 2
// ONLY LINE 1 OPEN
// ======================================================

else if (
  isXV2604Open &&
  !isXV2605Open
) {

  // ==========================================
  // ALL FLOW TO LINE 1
  // ==========================================

  FIC_2606 =
    totalGasFlow * 0.998;

  FIC_2607 = 0;

  // ==========================================
  // PRESSURES
  // ==========================================

  PT_2606 =
    PT_2601 * 0.985;

  PT_2607 = 0.03;

  // ==========================================
  // TEMPERATURES
  // ==========================================

  TT_2606 =
    TT_2604 * 0.998;

  TT_2607 = 25;
}

// ======================================================
// CASE 3
// ONLY LINE 2 OPEN
// ======================================================

else if (
  !isXV2604Open &&
  isXV2605Open
) {

  // ==========================================
  // ALL FLOW TO LINE 2
  // ==========================================

  FIC_2607 =
    totalGasFlow * 0.998;

  FIC_2606 = 0;

  // ==========================================
  // PRESSURES
  // ==========================================

  PT_2607 =
    PT_2601 * 0.985;

  PT_2606 = 0.03;

  // ==========================================
  // TEMPERATURES
  // ==========================================

  TT_2607 =
    TT_2604 * 0.998;

  TT_2606 = 25;
}

// ======================================================
// CASE 4
// BOTH LINES OPEN
// ======================================================

else {

  // ==========================================
  // FLOW SPLIT
  // ==========================================

  FIC_2606 =
    (totalGasFlow * 0.5) * 0.998;

  FIC_2607 =
    (totalGasFlow * 0.5) * 0.998;

  // ==========================================
  // PRESSURE LOSSES
  // ==========================================

  PT_2606 =
    PT_2601 * 0.982;

  PT_2607 =
    PT_2601 * 0.982;

  // ==========================================
  // TEMPERATURE LOSSES
  // ==========================================

  TT_2606 =
    TT_2604 * 0.999;

  TT_2607 =
    TT_2604 * 0.999;
}






// ======================================================
// FIQ-2601 TOTALIZER
// ======================================================

/*
  TOTALIZES:

  FIC_2606
  +
  FIC_2607

  EVERY SECOND

  IF isXV2603Open = true
  →
  NO FLOW TO TOTALIZER
  →
  TOTALIZER PAUSES
*/


 // ====================================================
// FIQ-2601 TOTALIZER (FIXED & STABLE)
// ====================================================

const [FIQ_2601, setFIQ_2601] = useState(() => {
  return Number(localStorage.getItem("FIQ_2601")) || 0;
});

const [lastFIQ2601, setLastFIQ2601] = useState(() => {
  return Number(localStorage.getItem("FIQ_2601_LAST")) || 0;
});

// ====================================================
// RESET LOCK (PREVENTS IMMEDIATE RE-UPDATE)
// ====================================================

const [resetLock, setResetLock] = useState(false);

// ====================================================
// VALVE LOGIC
// NOTE: true = CLOSED, false = OPEN
// ====================================================

// ====================================================
// TOTALIZER ENGINE
// ====================================================

useEffect(() => {

  const interval = setInterval(() => {

    // ============================================
    // BLOCK IF RESET ACTIVE
    // ============================================

    if (resetLock) return;

    // ============================================
    // BLOCK IF VALVE IS CLOSED
    // ============================================

    if (isXV2603Closed) return;

    // ============================================
    // TOTAL FLOW INPUT
    // ============================================

    const flow1 = Number(FIC_2606) || 0;
    const flow2 = Number(FIC_2607) || 0;

    const totalFlow = flow1 + flow2;

    // ============================================
    // INCREMENT TOTALIZER
    // ============================================

    setFIQ_2601(prev => {
      const updated = prev + totalFlow;

      localStorage.setItem("FIQ_2601", updated);

      return updated;
    });

  }, 1000);

  return () => clearInterval(interval);

}, [
  FIC_2606,
  FIC_2607,
  isXV2603Closed,
  resetLock
]);



// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("FIC_2606", FIC_2606);
}, [FIC_2606]);

useEffect(() => {
  localStorage.setItem("FIC_2607", FIC_2607);
}, [FIC_2607]);





// ====================================================
// RESET BUTTON (INSTANT ZERO + STABLE HOLD)
// ====================================================

const resetFIQ2601 = () => {

  // ============================================
  // STORE LAST VALUE
  // ============================================

  setLastFIQ2601(FIQ_2601);

  localStorage.setItem("FIQ_2601_LAST", FIQ_2601);

  // ============================================
  // ACTIVATE RESET LOCK
  // ============================================

  setResetLock(true);

  // ============================================
  // FORCE ZERO DISPLAY IMMEDIATELY
  // ============================================

  setFIQ_2601(0);
  localStorage.setItem("FIQ_2601", 0);

  // ============================================
  // RELEASE AFTER 1 SECOND
  // ============================================

  setTimeout(() => {
    setResetLock(false);
  }, 1000);
};


useEffect(() => {
        localStorage.setItem("FIQ_2601", FIQ_2601);
        }, [FIQ_2601]);
    



                  


  return (
    <div className="GasExport-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "2px",
        left: "196px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "2px 320px"
      }}>
        GAS METERING AND EXPORT
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2601 */}
      <Valve
        className="XV-2601"
        tag="XV_2601"
        x={710}
        y={319}
        isClosed={valves.XV_2601}
        toggle={toggleValve}
      />

      {/* XV-2602 */}
      <Valve
        className="XV-2602"
        tag="XV_2602"
        x={1172}
        y={105}
        isClosed={valves.XV_2602}
        toggle={toggleValve}
        r={0}
      />

      
      {/* XV-2603 */}
      <Valve
        className="XV-2603"
        tag="XV_2603"
        x={1050}
        y={532}
        isClosed={valves.XV_2603}
        toggle={toggleValve}
        r={0}
      />

      
      {/* XV-2604 */}
      <Valve
        className="XV-2604"
        tag="XV_2604"
        x={630}
        y={460}
        isClosed={valves.XV_2604}
        toggle={toggleValve}
        r={0}
      />

      
      {/* XV-2605 */}
      <Valve
        className="XV-2605"
        tag="XV_2605"
        x={630}
        y={587}
        isClosed={valves.XV_2605}
        toggle={toggleValve}
        r={0}
      />


      
        {/* ================= CONTROL VALVES SVG ================= */}
        

        
         {/* PCV-2601 */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="PCV-2601"
          style={{ position: "absolute", left: 333, top: 451}}  onClick={() => openPanel("PCV_2601")}>
          
          <defs>
            <linearGradient id="metal_2601">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2601)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2601)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 260 + index * 40
              }}
            />
          ))}

      
      
      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.PCV_2601?.opening || 0)}
        x={349}
        y={496}
      />



      <Transmitter
        tag="TT-2602"
        value={[TT_2602]}
        x={1076}
        y={95}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER FROM FRESH WATER SUPPLY TO GAS EXPORT COOLER FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="PT-2602"
        value={[PT_2602]}
        x={986}
        y={95}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF WATER FROM FRESH WATER SUPPLY TO GAS EXPORT COOLER FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="FIC-2602"
        value={[FIC_2602]}
        x={899}
        y={95}
        unit="LPM"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF WATER FROM FRESH WATER SUPPLY TO GAS EXPORT COOLER FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="FIC-2601"
        value={[FIC_2601]}
        x={167}
        y={180}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS FROM EXPORT GAS COMPRESSORS TO GAS EXPORT COOLER"
      />

      <Transmitter
        tag="PT-2601"
        value={[PT_2601]}
        x={276}
        y={180}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS FROM EXPORT GAS COMPRESSORS TO GAS EXPORT COOLER"
      />

      <Transmitter
        tag="TT-2601"
        value={[TT_2601]}
        x={419}
        y={95}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS FROM EXPORT GAS COMPRESSORS TO GAS EXPORT COOLER"
      />
      
      <Transmitter
        tag="TT-2604"
        value={[TT_2604]}
        x={523}
        y={307}
        unit="°C"
        max={100}
        HH={90}
        H={80}
        L={14}
        LL={5}
        c="lime"
        description="TEMPERATURE OF GAS AT THE DISCHARGE OF EXPORT GAS COOLER TO GAS METERING AND EXPORT STATION"
      />

      <Transmitter
        tag="TT-2603"
        value={[TT_2603]}
        x={1076}
        y={312}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER FROM GAS EXPORT COOLER TO FRESH WATER RETURN LINE"
      />

      <Transmitter
        tag="PT-2603"
        value={[PT_2603]}
        x={986}
        y={312}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF WATER FROM GAS EXPORT COOLER TO FRESH WATER RETURN LINE"
      />

      <Transmitter
        tag="FIC-2603"
        value={[FIC_2603]}
        x={899}
        y={312}
        unit="LPM"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF WATER FROM GAS EXPORT COOLER TO FRESH WATER RETURN LINE"
      />

      <Transmitter
        tag="FIC-2604"
        value={[FIC_2604]}
        x={414}
        y={378}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS GOING TO METERING STATION"
      />

      <Transmitter
        tag="FIC-2605"
        value={[FIC_2605]}
        x={179}
        y={450}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS GOING TO FLARE HEADER"
      />

      <Transmitter
        tag="FIC-2606"
        value={[FIC_2606]}
        x={715}
        y={445}
        unit="SCF/S"
        max={200}
        HH={190}
        H={175}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS ON METERING SKID LINE ONE (1) TO EXPORT PIPELINE"
      />

      <Transmitter
        tag="PT-2606"
        value={[PT_2606]}
        x={799}
        y={445}
        unit="MPa"
        max={12}
        HH={11}
        H={10}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS ON METERING SKID LINE ONE (1) TO EXPORT PIPELINE"
      />

      <Transmitter
        tag="TT-2606"
        value={[TT_2606]}
        x={889}
        y={445}
        unit="°C"
        max={70}
        HH={68}
        H={57}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS ON METERING SKID LINE ONE (1) TO EXPORT PIPELINE"
      />

      <Transmitter
        tag="FIC-2607"
        value={[FIC_2607]}
        x={715}
        y={572}
        unit="SCF/S"
        max={200}
        HH={190}
        H={175}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS ON METERING SKID LINE ONE (2) TO EXPORT PIPELINE"
      />

      <Transmitter
        tag="PT-2607"
        value={[PT_2607]}
        x={799}
        y={572}
        unit="MPa"
        max={12}
        HH={11}
        H={10}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS ON METERING SKID LINE ONE (2) TO EXPORT PIPELINE"
      />

      <Transmitter
        tag="TT-2607"
        value={[TT_2607]}
        x={889}
        y={572}
        unit="°C"
        max={70}
        HH={68}
        H={57}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS ON METERING SKID LINE ONE (2) TO EXPORT PIPELINE"
      />

      <Transmitter
        tag="FIQ-2601"
        value={[FIQ_2601]}
        x={1139}
        y={513}
        unit="SCF/S"
        max={12000000}
        HH={11000000}
        H={8000000}
        L={20}
        LL={10}
        c="lime"
        description="TOTALIZE FOR GAS EXPERT PIPELINE FROM GAS METERING STATION"
      />






      <div
        onClick={resetFIQ2601}
        style={{
          position: "absolute",
          left: 1138,
          top: 531,

          width: 68,
          height: 18,

          background: "#aa0000",

          color: "white",

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          borderRadius: "2px",

          cursor: "pointer",

          fontWeight: "bold",

          border: "0.5px solid white",

          userSelect: "none"
        }}
      >
        RESET
      </div>

          
        


        


    </div>
  );
}


export default GasExport;